module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "theater2.2fd46d3f.png";